import {get, union, first, last, createSelector} from 'helpers';
import {occurance} from './occurance';
import {timestamp, date, filter} from 'store/common';
import {current} from 'store/activities/selectors/activities';
import {allDay} from 'store/activities/selectors/all-day';
import {times as getTimes} from 'store/activities/selectors/times';

const onetime = createSelector(
  [ current.byDate, timestamp ],
  ( byDate, timestamp ) => byDate[timestamp],
  { memoizeOptions: { maxSize: 100 } },
);

export const day = createSelector(
  [date, onetime, current.recurring, occurance],
  (date, onetime, recurring, getOccurance) => {
    const result = [];
    for (let activity of union(onetime, recurring)) {
      const occurance = getOccurance(activity);
      if (occurance) {
        //@todo fix
        const times = getTimes(activity);
        let time = occurance.priority || first(times);
        if (times.length > 1 && get(occurance, 'count')) {
          time = times[get(occurance, 'count')] || last(times);
        }
        if (occurance.duration && occurance.duration > 0) {
          activity = {
            ...activity,
            duration: parseInt(occurance.duration),
          }
        }
        if (occurance.priority) {
          activity = {
            ...activity,
            allDay: false,
          }
        } else if (allDay(activity)) {
          time = null;
        }
        result.push({
          ...activity,
          isActivity: true,
          occurance,
          status: occurance.status,
          time,
        });
      }
    }
    return result;
  },
  { memoizeOptions: { maxSize: 100 } },
);
